var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footerText"},[_c('h3',[_vm._v("PM-TW-1137-06-2018")]),_vm._v(" "),(_vm.text === '')?_c('small',[_vm._v("2018 American Society of Clinical Oncology (ASCO) – June 1-5, 2018, Chicago, IL, USA  Abstract #4523")]):_vm._e(),_vm._v(" "),(_vm.text !== '')?_c('small',{domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ac7d68c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/step5/footText.vue
// module id = null
// module chunks = 